import { Typography } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const data = [
  { month: "Jan", healthy: 160, low: 40, out: 20 },
  { month: "Feb", healthy: 280, low: 80, out: 10 },
  { month: "Mar", healthy: 140, low: 90, out: 30 },
  { month: "Apr", healthy: 200, low: 150, out: 0 },
  { month: "May", healthy: 140, low: 70, out: 40 },
  { month: "Jun", healthy: 120, low: 60, out: 10 },
  { month: "Jul", healthy: 260, low: 40, out: 30 },
];
const CustomLegend = () => {
  return (
    <div style={{ display: "flex", gap: 20, justifyContent: "center", marginBottom: 10 }}>
      
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ color: "#aaffa6", fontSize: 20 }}>●</span>
        <span style={{ color: "#003368" }}>Healthy Stock</span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ color: "#3ad432", fontSize: 20 }}>●</span>
        <span style={{ color: "#003368" }}>Low Stock</span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ color: "#0aa002", fontSize: 20 }}>●</span>
        <span style={{ color: "#003368" }}>Out-of-Stock</span>
      </div>

    </div>
  );
};

export default function InventoryChart() {
  return (
    <div style={{ width: "100%", height: 300 }}>
      <Typography variant="h3" mb="10px" fontSize="20px">
        Sales Overview
      </Typography>
      <Typography variant="body2" color="#989a9e" mb="20px">
        Best selling products and sales trends over the last 6 months.
      </Typography>

      <ResponsiveContainer width="100%" height="85%">
        <BarChart data={data} barCategoryGap={30}>
          
          {/* Grid */}
          <CartesianGrid strokeDasharray="3 3" vertical={false} />

          {/* X Axis */}
          <XAxis
            dataKey="month"
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          {/* Y Axis */}
          <YAxis
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            width={30}
          />

          {/* Tooltip */}
          <Tooltip />

          {/* Legend */}
          <Legend content={<CustomLegend />} />

          {/* Bars (STACKED + THIN) */}
          <Bar
            dataKey="out"
            stackId="a"
            fill="#0aa002"
            radius={[4, 4, 0, 0]}
            barSize={20}   // 👈 THIN BARS
          />
          <Bar
            dataKey="low"
            stackId="a"
            fill="#3ad432"
            barSize={20}
          />
          <Bar
            dataKey="healthy"
            stackId="a"
            fill="#aaffa6"
            barSize={20}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}